import { Message } from "@/store/chats/types";

export const getIsMyMessage = (message: Message, authId: number): boolean => {
  return message.senderId === authId;
};
